module.exports = __webpack_public_path__ + "static/media/28.d63b5838.jpg";